/**
 * RowAction: the icon button at the right edge of a SettingsListRow
 * (rename, revoke, remove, delete). Muted until hovered; a destructive
 * action turns red on hover, so the color says what the click does before
 * it happens. `label` is required: the icon alone never names the action.
 */

import type { LucideIcon } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface RowActionProps {
  label: string
  icon: LucideIcon
  onClick: () => void
  disabled?: boolean
  destructive?: boolean
}

export function RowAction({
  label,
  icon: Icon,
  onClick,
  disabled = false,
  destructive = false,
}: RowActionProps): React.JSX.Element {
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      aria-label={label}
      title={label}
      disabled={disabled}
      onClick={onClick}
      className={destructive ? 'shrink-0 text-muted-foreground hover:text-destructive' : 'shrink-0 text-muted-foreground'}
    >
      <Icon />
    </Button>
  )
}
